export default "__VITE_ASSET__1ZQ1HNlI__"